<div class="vc-image-container">
    <input
        #fileInput
        type="file"
        accept="image/png,image/jpeg,image/jpg,image/webp,image/gif"
        multiple
        (change)="handleFileChange($event)"
        style="display: none; position: absolute;"
    />
    @if (!!uploadedImages().length || showFigmaLink) {
        <div class="uploadedImagesContainer" [class.withImages]="!!uploadedImages().length" [class.withFigmaLink]="showFigmaLink && !figmaResp">
          @if (showFigmaLink) {
                <db-figma-link
                        [class.twoLines]="!figmaResp"
                        (figmaRespTrigger)="setFigmaResp($event)"
                               (closeFigma)="closeFigma.emit(); showFigmaLink = false"></db-figma-link>
            }
            @for (image of uploadedImages(); track image.id; let i = $index) {
                <div class="uploadedWrap">
                    <div class="uploadedImageWrap show"
                         [style]="{backgroundImage: `url(${image.src})`}">
                        @if (image.isUploading) {
                            <div class="uploadingSpinner">
                                <img src="assets\images\loading\spinner-dotted-white.svg"/>
                            </div>
                        }

                    </div>
                    <span (click)="removeImageByIndex(i)">
                    <i class="db-icon db-icon-close"></i>
                </span>
                </div>
            }

            @if (figmaResp && uploadedImages().length) {
                <div class="imagePlaceholder"></div>
            }
        </div>

        <div class="imageContainerEndCover"></div>
    }

</div>
